import {ChangeDetectionStrategy, Component, computed, Injectable, input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {EnkelGruppeModell, GruppeMedlemListeModell, GruppeMedlemRessursClient, MedlemAssosiasjonerModell, MedlemId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {tomMedlemAssosiasjonerModell} from "felles-ng2/modell/medlemModellHjelpere";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {Observable, switchMap} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";

const debug = initDebugger('MedlemStengTilgangBekreftelseKomponent');

@Component({
    selector: 'medlem-steng-tilgang-bekreftelse',
    templateUrl: 'medlem-steng-tilgang-bekreftelse.html',
    styleUrl: 'medlem-steng-tilgang-bekreftelse.scss',
    imports: [
        TranslateModule,
        TipsKomponent,
        InlineMeldingKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemStengTilgangBekreftelseKomponent {

    gruppe = input.required<EnkelGruppeModell>();
    medlem = input.required<GruppeMedlemListeModell>();

    assosiasjoner = toSignal(toObservable(this.medlem).pipe(switchMap(medlem => this.avhengigheter.assosiasjoner(medlem.id))),
      {initialValue: tomMedlemAssosiasjonerModell()})

    harAssosiasjoner = computed(() =>
      this.assosiasjoner!().antTilknyttetFremtidigIkkelaastMoeteSomDeltaker > 0 ||
      this.assosiasjoner!().antTilknyttetFremtidigIkkelaastProtokollSomDeltaker > 0 ||
      this.assosiasjoner!().antTilknyttetFremtidigIkkelaastSakSomAnsvarlig > 0 ||
      this.assosiasjoner!().erTilknyttetMalmoete
    );

    constructor(private avhengigheter: MedlemStengTilgangBekreftelseKomponentAvhengigheter) {
    }
}

@Injectable()
export class MedlemStengTilgangBekreftelseKomponentAvhengigheter {

    constructor(private gruppeMedlemRessurs: GruppeMedlemRessursClient) {
    }

    assosiasjoner(id: MedlemId): Observable<MedlemAssosiasjonerModell> {
        return this.gruppeMedlemRessurs.assosiasjoner(id).somObservable();
    }
}
